import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import Quill from 'quill';
import Parchment from 'parchment';
// import IconAlignLeft from 'quill/assets/icons/align-left.svg';
// import IconAlignCenter from 'quill/assets/icons/align-center.svg';
// import IconAlignRight from 'quill/assets/icons/align-right.svg';
import { BaseModule } from './BaseModule';

/*
I decided to inline these icons because these were originally based on
the quill npm package.  At any time, they might change or the file names might
change.  I left the original imports above for future reference.
*/
var IconAlignLeft = "<svg viewbox=\"0 0 18 18\">\n<line class=\"ql-stroke\" x1=\"3\" x2=\"15\" y1=\"9\" y2=\"9\"></line>\n<line class=\"ql-stroke\" x1=\"3\" x2=\"13\" y1=\"14\" y2=\"14\"></line>\n<line class=\"ql-stroke\" x1=\"3\" x2=\"9\" y1=\"4\" y2=\"4\"></line>\n</svg>";
var IconAlignCenter = "<svg viewbox=\"0 0 18 18\">\n<line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"></line>\n<line class=\"ql-stroke\" x1=\"14\" x2=\"4\" y1=\"14\" y2=\"14\"></line>\n<line class=\"ql-stroke\" x1=\"12\" x2=\"6\" y1=\"4\" y2=\"4\"></line>\n</svg>";
var IconAlignRight = "<svg viewbox=\"0 0 18 18\">\n<line class=\"ql-stroke\" x1=\"15\" x2=\"3\" y1=\"9\" y2=\"9\"></line>\n<line class=\"ql-stroke\" x1=\"15\" x2=\"5\" y1=\"14\" y2=\"14\"></line>\n<line class=\"ql-stroke\" x1=\"15\" x2=\"9\" y1=\"4\" y2=\"4\"></line>\n</svg>";
var FloatStyle = new Parchment.Attributor.Style('float', 'float');
var MarginStyle = new Parchment.Attributor.Style('margin', 'margin');
var DisplayStyle = new Parchment.Attributor.Style('display', 'display');
var offsetAttributor = new Parchment.Attributor.Attribute('nameClass', 'class', {
  scope: Parchment.Scope.INLINE
});
Quill.register(offsetAttributor);

/*
no-invalid-this: "off" is justified because the way this object is created
is a bit different than a standard object.  this is essentially a plugin to quill,
so it needs it's own standardized API to create/destroy, etc.
*/

/* eslint no-invalid-this: "off" */
export var Toolbar = /*#__PURE__*/function (_BaseModule) {
  _inheritsLoose(Toolbar, _BaseModule);
  function Toolbar() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _BaseModule.call.apply(_BaseModule, [this].concat(args)) || this;
    _this.onCreate = function () {
      // Setup Toolbar
      _this.toolbar = document.createElement('div');
      Object.assign(_this.toolbar.style, _this.options.toolbarStyles);
      _this.overlay.appendChild(_this.toolbar);

      // Setup Buttons
      _this.defineAlignments();
      _this.addToolbarButtons();
    };
    // The toolbar and its children will be destroyed when the overlay is removed
    /* eslint no-empty-function: "off" */
    _this.onDestroy = function () {};
    // Nothing to update on drag because we are are positioned relative to the overlay
    /* eslint no-empty-function: "off" */
    _this.onUpdate = function () {};
    _this.defineAlignments = function () {
      _this.alignments = [{
        icon: IconAlignLeft,
        apply: function apply() {
          DisplayStyle.add(_this.img, 'inline');
          FloatStyle.add(_this.img, 'left');
          MarginStyle.add(_this.img, '0 1em 1em 0');
          _this.img.align = 'left';
        },
        isApplied: function isApplied() {
          return FloatStyle.value(_this.img) === 'left';
        }
      }, {
        icon: IconAlignCenter,
        apply: function apply() {
          DisplayStyle.add(_this.img, 'block');
          FloatStyle.remove(_this.img);
          MarginStyle.add(_this.img, 'auto');
          _this.img.align = 'center';
        },
        isApplied: function isApplied() {
          return MarginStyle.value(_this.img) === 'auto';
        }
      }, {
        icon: IconAlignRight,
        apply: function apply() {
          DisplayStyle.add(_this.img, 'inline');
          FloatStyle.add(_this.img, 'right');
          MarginStyle.add(_this.img, '0 0 1em 1em');
          _this.img.align = 'right';
        },
        isApplied: function isApplied() {
          return FloatStyle.value(_this.img) === 'right';
        }
      }];
    };
    _this.addToolbarButtons = function () {
      var buttons = [];
      _this.alignments.forEach(function (alignment, idx) {
        var button = document.createElement('span');
        buttons.push(button);
        button.innerHTML = alignment.icon;
        button.addEventListener('click', function () {
          // deselect all buttons
          buttons.forEach(function (button) {
            button.style.filter = '';
            return button.style.filter;
          });
          if (alignment.isApplied()) {
            // If applied, unapply
            FloatStyle.remove(_this.img);
            MarginStyle.remove(_this.img);
            DisplayStyle.remove(_this.img);
          } else {
            // otherwise, select button and apply
            _this.selectButton(button);
            alignment.apply();
          }
          // image may change position; redraw drag handles
          _this.requestUpdate();
        });
        Object.assign(button.style, _this.options.toolbarButtonStyles);
        if (idx > 0) {
          button.style.borderLeftWidth = '0';
        }
        Object.assign(button.children[0].style, _this.options.toolbarButtonSvgStyles);
        if (alignment.isApplied()) {
          // select button if previously applied
          _this.selectButton(button);
        }
        _this.toolbar.appendChild(button);
      });
    };
    _this.selectButton = function (button) {
      button.style.filter = 'invert(20%)';
    };
    return _this;
  }
  return Toolbar;
}(BaseModule);